module.exports = __webpack_public_path__ + "static/media/smartpass.fa0e92d5.png";